<div class="">
  <a class="b-brand">
    <!--<div class="b-bg">
      <i class="feather icon-trending-up"></i>
    </div>
    <span class="b-title">Datta Able</span>-->
    <span class="logo-lg"><img src="assets/images/logo-dark.png" alt="" height="25"></span>
  </a>
  <a href="javascript:" class="mobile-menu" [ngClass]="{ on: navCollapsed }" id="mobile-collapse" (click)="navCollapse()"><span></span></a>
</div>
